import { useRef, useState, useEffect } from "react";
import NepaliDatePicker from '@zener/nepali-datepicker-react';
import '@zener/nepali-datepicker-react/index.css';
import "./MoneyForm.css";

export default function MoneyForm({
    form,
    setForm,
    users,
    onSubmit,
    onShowUserModal,
    submitting,
    onEditUser,
    onDeleteUser
}) {
    const firstRef = useRef();
    const [showUserDropdown, setShowUserDropdown] = useState(false);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!event.target.closest('.dropdown')) {
                setShowUserDropdown(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const handleUserSelect = (userId) => {
        setForm(prev => ({ ...prev, userId }));
        setShowUserDropdown(false);
    };

    const handleUserEdit = (user, e) => {
        e.stopPropagation();
        setShowUserDropdown(false);
        if (onEditUser) {
            onEditUser(user);
        }
    };

    const handleUserDelete = (user, e) => {
        e.stopPropagation();
        setShowUserDropdown(false);
        if (onDeleteUser) {
            onDeleteUser(user);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm(prev => ({ ...prev, [name]: value }));
        if (name === "userId" && value === "create_user") onShowUserModal(true);
    };

    return (
        <div className="money-form-inline">
            <h6 className="money-form-title">Add New Transaction</h6>
            <form onSubmit={onSubmit} className="row g-3 mb-4 align-items-end">
                <div className="col-md-2">
                    <select
                        ref={firstRef}
                        name="givenOrTaken"
                        className="form-select"
                        value={form.givenOrTaken}
                        onChange={handleChange}
                        required
                        disabled={submitting}
                    >
                        <option value="">Debit/Credit</option>
                        <option value="Debit">Debit</option>
                        <option value="Credit">Credit</option>
                    </select>
                </div>

                <div className="col-md-3">
                    <div className="dropdown">
                        <button
                            className="btn btn-outline-secondary dropdown-toggle w-100 text-start"
                            type="button"
                            onClick={() => setShowUserDropdown(!showUserDropdown)}
                            disabled={submitting}
                        >
                            {form.userId ? users.find(u => u._id === form.userId)?.username || "Select User" : "Select User"}
                        </button>
                        {showUserDropdown && (
                            <ul className="dropdown-menu show w-100" style={{ maxHeight: '200px', overflowY: 'auto' }}>
                                {users.map(u => (
                                    <li key={u._id} className="d-flex align-items-center px-2 py-1">
                                        <button
                                            className="btn btn-link text-decoration-none flex-grow-1 text-start p-0"
                                            onClick={() => handleUserSelect(u._id)}
                                        >
                                            {u.username}
                                        </button>
                                        <button
                                            className="btn btn-sm btn-outline-primary ms-1"
                                            onClick={(e) => handleUserEdit(u, e)}
                                            title="Edit user"
                                        >
                                            ✏️
                                        </button>
                                        <button
                                            className="btn btn-sm btn-outline-danger ms-1"
                                            onClick={(e) => handleUserDelete(u, e)}
                                            title="Delete user"
                                        >
                                            🗑️
                                        </button>
                                    </li>
                                ))}
                                <li className="px-2 py-1">
                                    <button
                                        className="btn btn-link text-primary text-decoration-none w-100 text-start p-0"
                                        onClick={() => {
                                            setShowUserDropdown(false);
                                            onShowUserModal(true);
                                        }}
                                    >
                                        + New User
                                    </button>
                                </li>
                            </ul>
                        )}
                    </div>
                </div>

                <div className="col-md-2">
                    <input
                        type="number"
                        name="amount"
                        placeholder="Amount (₹)"
                        className="form-control"
                        value={form.amount}
                        onChange={handleChange}
                        required
                        disabled={submitting}
                    />
                </div>

                <div className="col-md-2">
                    <NepaliDatePicker
                        value={form.date ? new Date(form.date) : null}
                        onChange={(date) => {
                            if (date) {
                                const regularDate = date.toADasDate ? date.toADasDate() : date;
                                setForm(prev => ({ ...prev, date: regularDate.toISOString() }));
                            } else {
                                setForm(prev => ({ ...prev, date: null }));
                            }
                        }}
                        placeholder="Select BS Date"
                        className="form-control"
                        disabled={submitting}
                        type="BS"
                    />
                </div>

                <div className="col-md-3">
                    <input
                        type="text"
                        name="remarks"
                        placeholder="Remarks (optional)"
                        className="form-control"
                        value={form.remarks}
                        onChange={handleChange}
                        disabled={submitting}
                    />
                </div>

                <div className="col-md-12 text-end">
                    <button
                        className="btn btn-success"
                        type="submit"
                        disabled={submitting}
                    >
                        {submitting ? "Adding..." : "Add Transaction"}
                    </button>
                </div>
            </form>
        </div>
    );
}